<script setup lang="ts">
import { TriangleAlert } from '@lucide/vue'
import { RouterView } from 'vue-router'

import AppSidebar from '#app/components/AppSidebar.vue'
import { useEnvironment } from '#app/composables/use-environment'
import { Alert, AlertDescription, AlertTitle } from '#ui/alert'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '#ui/sidebar'
import { PAGE_MOTION } from '#utils/motion'

const { environment } = useEnvironment()

const sidebarDefaultOpen =
  typeof document !== 'undefined' && document.cookie.includes('sidebar_state=true')
</script>

<template>
  <SidebarProvider :default-open="sidebarDefaultOpen" class="bg-sidebar">
    <AppSidebar />
    <SidebarInset class="h-svh bg-transparent">
      <header class="flex h-14 shrink-0 items-center gap-2 px-3">
        <SidebarTrigger class="-ml-1" />
        <span
          v-if="environment === 'production'"
          class="inline-flex items-center gap-1.5 rounded-full bg-destructive/10 px-2.5 py-0.5 text-xs font-medium text-destructive"
        >
          <span class="size-1.5 rounded-full bg-destructive" />
          Production
        </span>
        <div id="app-header-actions" class="mr-1 ml-auto flex items-center gap-1.5" />
      </header>
      <div
        data-page-scroll
        class="mx-2 mb-2 flex min-h-0 flex-1 flex-col overflow-y-auto rounded-xl border bg-card p-6"
      >
        <div class="mx-auto flex w-full max-w-6xl flex-col gap-6">
          <Alert v-if="environment === 'production'" variant="warning">
            <TriangleAlert />
            <AlertTitle>You are editing production</AlertTitle>
            <AlertDescription>
              Changes here affect real customers immediately. Switch to Acceptance in the sidebar to
              experiment safely.
            </AlertDescription>
          </Alert>
          <RouterView v-slot="{ Component, route }">
            <Transition v-bind="PAGE_MOTION">
              <div :key="route.path" class="flex flex-col gap-6">
                <component :is="Component" />
              </div>
            </Transition>
          </RouterView>
        </div>
      </div>
    </SidebarInset>
  </SidebarProvider>
</template>
